import React from 'react';

const MobileServiceSection = () => {
  return (
    <>
      <style jsx>{`
        .mobile-service-section {
          background: white;
          padding: 80px 40px;
          position: relative;
          overflow: hidden;
          padding-right: 0px;
        }

        .mobile-service-container {
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }

        .section-header-3 {
          display: flex;
          align-items: center;
          gap: 20px;
          margin-bottom: 60px;
          animation: fadeInLeft 0.8s ease-out;
        }

        .car-icon-10 {
          font-size: 3.5rem;
          color: #2196F3;
          animation: bounce 2s ease-in-out infinite;
        }

        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }

        .section-title {
          font-size: 3.2rem;
          font-weight: bold;
          color: #2196F3;
          margin: 0;
          font-family: 'Arial', sans-serif;
          text-shadow: 2px 2px 4px rgba(33, 150, 243, 0.1);
        }

        .content-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
        }

        .content-left {
          animation: slideInLeft 0.8s ease-out 0.2s both;
          padding-left: 60px;
        }

        .service-header {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 30px;
        }

        .wrench-icon {
          font-size: 2.5rem;
          color: #666;
          animation: wrenchRotate 3s ease-in-out infinite;
        }

        @keyframes wrenchRotate {
          0%, 100% { transform: rotate(0deg); }
          25% { transform: rotate(-15deg); }
          75% { transform: rotate(15deg); }
        }

        .service-title {
          font-size: 2.2rem;
          font-weight: bold;
          color: #2196F3;
          margin: 0;
          font-family: 'Arial', sans-serif;
        }

        .service-description {
          font-size: 1.3rem;
          color: #666;
          line-height: 1.6;
          margin: 0 0 30px 0;
          font-family: 'Arial', sans-serif;
        }

        .shell-highlight {
          color: #FFD700;
          font-weight: bold;
        }

        .destination-section {
          margin: 40px 0;
        }

        .destination-title {
          font-size: 1.8rem;
          font-weight: bold;
          color: #2196F3;
          margin: 0 0 20px 0;
          font-family: 'Arial', sans-serif;
        }

        .destination-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .destination-item {
          display: flex;
          align-items: center;
          gap: 15px;
          font-size: 1.2rem;
          color: #666;
          margin: 12px 0;
          font-family: 'Arial', sans-serif;
          animation: fadeInUp 0.6s ease-out;
        }

        .destination-item:nth-child(1) { animation-delay: 0.4s; }
        .destination-item:nth-child(2) { animation-delay: 0.6s; }
        .destination-item:nth-child(3) { animation-delay: 0.8s; }

        .bullet-point {
          width: 8px;
          height: 8px;
          background: #2196F3;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .cta-button {
          background: white;
          border: 3px solid #2196F3;
          border-radius: 15px;
          padding: 18px 35px;
          display: flex;
          align-items: center;
          gap: 20px;
          font-size: 1.6rem;
          font-weight: bold;
          color: #2196F3;
          cursor: pointer;
          transition: all 0.3s ease;
          max-width: fit-content;
          margin-top: 40px;
          text-decoration: none;
          box-shadow: 0 8px 25px rgba(33, 150, 243, 0.2);
          animation: fadeInUp 0.8s ease-out 1s both;
        }

        .cta-button:hover {
          background: #2196F3;
          color: white;
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(33, 150, 243, 0.4);
        }

        .cta-button:focus {
          outline: 3px solid rgba(33, 150, 243, 0.5);
          outline-offset: 2px;
        }

        .cta-button:hover .button-van-icon {
          background: white;
        }

        .cta-button img {
          transition: filter 0.3s ease;
        }

        .cta-button:hover img {
          filter: brightness(0) invert(1);
        }

        .button-van-icon {
          width: 50px;
          height: 35px;
          background: url('https://placehold.co/600x400@2x.png') center/cover no-repeat;
          border-radius: 8px;
          position: relative;
          transition: all 0.3s ease;
        }

        .content-right {
          position: relative;
          animation: slideInRight 0.8s ease-out 0.4s both;
        }

        .van-showcase {
          position: relative;
          width: 100%;
          height: 620px;
          perspective: 1000px;
        }

        .van-image {
          width: 100%;
          height: 100%;
          background: url('/images/faucon_bleu.png') center/cover no-repeat;
          border-radius: 20px;
          position: relative;
          transition: all 0.5s ease;
          animation: vanFloat 4s ease-in-out infinite;
        }

        @keyframes vanFloat {
          0%, 100% { transform: translateY(0px) rotateY(0deg); }
          50% { transform: translateY(-15px) rotateY(2deg); }
        }

        .van-image:hover {
          transform: scale(1.05) rotateY(5deg);
        }

        .van-shadow {
          position: absolute;
          bottom: -20px;
          left: 50%;
          transform: translateX(-50%);
          width: 80%;
          height: 40px;
          background: radial-gradient(ellipse, rgba(0,0,0,0.3) 0%, transparent 70%);
          border-radius: 50%;
          animation: shadowPulse 4s ease-in-out infinite;
        }

        @keyframes shadowPulse {
          0%, 100% { opacity: 0.3; transform: translateX(-50%) scale(1); }
          50% { opacity: 0.5; transform: translateX(-50%) scale(1.1); }
        }

        .decorative-elements {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          pointer-events: none;
        }

        .floating-icon {
          position: absolute;
          font-size: 2rem;
          opacity: 0.1;
          animation: floatRandom 8s ease-in-out infinite;
        }

        .floating-icon:nth-child(1) {
          top: 10%;
          left: 5%;
          animation-delay: 0s;
        }

        .floating-icon:nth-child(2) {
          top: 80%;
          right: 10%;
          animation-delay: 2s;
        }

        .floating-icon:nth-child(3) {
          top: 30%;
          right: 5%;
          animation-delay: 4s;
        }

        @keyframes floatRandom {
          0%, 100% { transform: translate(0, 0) rotate(0deg); }
          25% { transform: translate(20px, -30px) rotate(5deg); }
          50% { transform: translate(-15px, -40px) rotate(-5deg); }
          75% { transform: translate(-25px, -20px) rotate(3deg); }
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-100px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(100px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @media (max-width: 1024px) {
          .content-grid {
            grid-template-columns: 1fr;
            gap: 50px;
          }

          .section-title {
            font-size: 2.8rem;
          }

          .service-title {
            font-size: 2rem;
          }

          .service-description {
            font-size: 1.2rem;
          }

          .van-showcase {
            height: 350px;
          }
        }

        @media (max-width: 768px) {
          .mobile-service-section {
            padding: 60px 20px;
            padding-right: 0px;
          }

          .section-header-3 {
            flex-direction: column;
            text-align: center;
            gap: 15px;
            margin-bottom: 40px;
          }

          .section-title {
            font-size: 2.2rem;
          }

          .content-left {
            padding-left: 0;
            text-align: center;
          }

          .service-header {
            justify-content: center;
          }

          .service-title {
            font-size: 1.8rem;
          }

          .service-description {
            font-size: 1.1rem;
          }

          .destination-title {
            font-size: 1.6rem;
          }

          .destination-item {
            font-size: 1.1rem;
            justify-content: center;
          }

          .cta-button {
            font-size: 1.4rem;
            padding: 15px 30px;
            width: 100%;
            justify-content: center;
            max-width: 300px;
            margin: 40px auto 0;
          }

          .van-showcase {
            height: 300px;
          }
        }

        @media (max-width: 480px) {
          .mobile-service-section {
            padding: 50px 15px;
            padding-right: 0px;
          }

          .section-title {
            font-size: 1.8rem;
          }

          .service-title {
            font-size: 1.5rem;
          }

          .service-description {
            font-size: 1rem;
          }

          .destination-title {
            font-size: 1.4rem;
          }

          .destination-item {
            font-size: 1rem;
          }

          .cta-button {
            font-size: 1.2rem;
            padding: 12px 25px;
            width: 100%;
            max-width: 280px;
          }

          .cta-button img {
            width: 50px;
            height: auto;
          }

          .van-showcase {
            height: 250px;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }
      `}</style>

      <section 
        className="mobile-service-section"
        role="region"
        aria-labelledby="mobile-service-heading"
        itemScope
        itemType="https://schema.org/Service"
      >
        <div className="decorative-elements" aria-hidden="true">
          <div className="floating-icon">🔧</div>
          <div className="floating-icon">🚐</div>
          <div className="floating-icon">⚙️</div>
        </div>

        <div className="mobile-service-container">
          <header className="section-header-3">
            <div className="car-icon-10" role="img" aria-label="Service automobile">🚙</div>
            <h2 id="mobile-service-heading" className="section-title" itemProp="name">
              Nos services
            </h2>
          </header>

          <div className="content-grid">
            <div className="content-left">
              <header className="service-header">
                <div className="wrench-icon" role="img" aria-label="Outils de mécanique">🔧</div>
                <h3 className="service-title">Atelier mobile – Vidange à domicile</h3>
              </header>

              <p className="service-description" itemProp="description">
                Faites votre vidange sans vous déplacer. Un technicien se rend à votre domicile<br />
                ou votre lieu de travail, équipé de tout le nécessaire.<br />
                Nous utilisons des huiles <span className="shell-highlight">Shell Helix</span> et des filtres de haute qualité, pour un<br />
                service rapide, propre et professionnel.
              </p>

              <div className="destination-section">
                <h4 className="destination-title">Destiné à :</h4>
                <ul className="destination-list" role="list">
                  <li className="destination-item" role="listitem">
                    <div className="bullet-point" aria-hidden="true"></div>
                    <span>Particuliers pressés</span>
                  </li>
                  <li className="destination-item" role="listitem">
                    <div className="bullet-point" aria-hidden="true"></div>
                    <span>Conducteurs professionnels</span>
                  </li>
                  <li className="destination-item" role="listitem">
                    <div className="bullet-point" aria-hidden="true"></div>
                    <span>Entreprises souhaitant maintenir leur<br />flotte sans immobilisation</span>
                  </li>
                </ul>
              </div>

              <a 
                href="#reserver-atelier-mobile" 
                className="cta-button"
                role="button"
                aria-label="Réserver un service d'atelier mobile à domicile"
                itemProp="url"
              >
                <img 
                  src='/images/car_small.png' 
                  alt="Véhicule de service mobile"
                  height={64} 
                  width={120}
                  loading="lazy"
                />
                Réserver Atelier Mobile
              </a>
            </div>

            <div className="content-right">
              <div className="van-showcase">
                <div 
                  className="van-image"
                  role="img"
                  aria-label="Véhicule atelier mobile Faucon Bleu"
                  itemProp="image"
                ></div>
                <div className="van-shadow" aria-hidden="true"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Structured Data for SEO */}
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Service",
              "name": "Atelier mobile - Vidange à domicile",
              "description": "Service de vidange automobile à domicile. Technicien équipé se déplace chez vous avec huiles Shell Helix et filtres de qualité.",
              "provider": {
                "@type": "AutoRepair",
                "name": "Faucon Bleu",
                "url": "https://fauconbleu.ma"
              },
              "areaServed": {
                "@type": "City",
                "name": "Casablanca",
                "addressCountry": "MA"
              },
              "serviceType": "Mobile Oil Change",
              "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Services atelier mobile",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Vidange à domicile",
                      "description": "Service de vidange mobile pour particuliers et professionnels"
                    }
                  }
                ]
              },
              "audience": [
                {
                  "@type": "Audience",
                  "audienceType": "Particuliers pressés"
                },
                {
                  "@type": "Audience", 
                  "audienceType": "Conducteurs professionnels"
                },
                {
                  "@type": "Audience",
                  "audienceType": "Entreprises avec flotte automobile"
                }
              ]
            })
          }}
        />
      </section>
    </>
  );
};

export default MobileServiceSection;